export const MINIMUM_LIFETIME_REWARD_BALANCE_FOR_WITHDRAWAL = 15;
